import(/* webpackMode: "eager" */ "/app/src/app/compare/chatgpt/page.tsx");
